"use client";

import SocketNotificationCustom from "@/components/shared/notification";
import React, { Suspense } from "react";

export default function Layout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <React.Fragment>
      <Suspense>{children}</Suspense>
      <SocketNotificationCustom />
    </React.Fragment>
  );
}
